<div class="commonPopup">
  <ng-template pTemplate="header"></ng-template>
  <div class="trialCont">
    <!-- Image Section -->
    <div class="img">
      <img src="/assets/images/html/Trial-Expired-2.webp" alt="Trial Expired" />
    </div>

    <!-- Content Section -->

    <div class="textCont">
      <div>
        <h1>No Active Plan Found</h1>
        <p>
          Your workspace currently has no active plan. Choose a plan that fits your needs and unlock
          powerful tools to manage your social media efficiently.
        </p>

        <!-- Features List -->
        <ul>
          <li>
            ✅
            <div>
              <strong>All-in-One Social Media Management </strong>
              <p>Plan, schedule, and organize content effortlessly.</p>
            </div>
          </li>
          <li>
            🤖
            <div>
              <strong>AI-Powered Content Creation</strong>
              <p>
                Generate engaging posts using AI-driven prompts, and optimize your reach with smart
                hashtag tools.
              </p>
            </div>
          </li>
          <li>
            📊
            <div>
              <strong>In-Depth Social Media Analytics</strong>
              <p>Track your performance across all platforms with in-depth reports.</p>
            </div>
          </li>
          <li>
            👥
            <div>
              <strong>Team Collaboration & Approval Workflows</strong>
              <p>
                Invite team members, share drafts, leave feedback, and approve content with ease.
              </p>
            </div>
          </li>
        </ul>
        🔓 Get Started Today – Pick Your Plan!
      </div>
      <div class="d-md-flex mt-auto justify-content-end bottomBtn">
        <p-button
          label="Upgrade plan"
          icon="pi pi-arrow-up-right"
          iconPos="right"
          (click)="onGoPremium()"
          routerLink="/plans"
        />
      </div>
    </div>
  </div>
</div>
